import { getAssets, upperFirstLetter } from "@unisearch/helpers";
import Link from "next/link";
import React from "react";
import styles from "./uni_card_head.module.scss";

const UniCardHead = ({ data }) => {
  return (
    <div className={styles.uni_rank_card}>
      <div className={styles.uni_image_wrapper}>
        <img
          src={
            data.featureImageSrc ??
            getAssets("assets/images/image_placeholder_big.webp")
          }
          alt={data.universityName ?? ""}
        />
      </div>

      <div className={styles.uni_card_top}>
        {/* {data.rankFrom && parseInt(data.rankFrom) != 0 && (
          <div className={styles.uni_rank}>
            Rank: {data.rankingVarying}
            {data.rankFrom} {parseInt(data.rankTo) != 0 && " - " + data.rankTo}
          </div>
        )} */}

        {data.logoSrc && (
          <Link legacyBehavior href={data.link || "#"}>
            <a className={styles.uni_logo_wrapper}>
              <img src={data.logoSrc} alt="University Logo" />
            </a>
          </Link>
        )}

        <Link legacyBehavior href={data.link || "#"}>
          <a className={styles.uni_name}>{data.universityName}</a>
        </Link>
        <p className={styles.uni_address}>
          {data.universityType ? upperFirstLetter(data.universityType) : ""}{" "}
          university, Estd {data.estd}
        </p>
        <p className={styles.uni_address} style={{ maxWidth: "255px" }}>
          {data.address}
        </p>

        {/* <div className={styles.favorite_wrapper}>
          <FaRegHeart />
          <MdSwapCalls
            style={{ fontSize: "20px", transform: "rotate(90deg)" }}
          />
        </div> */}
      </div>
    </div>
  );
};

export default UniCardHead;
